import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Webinars from './pages/Webinars';
import WebinarDetail from './pages/WebinarDetail';
import WebinarPublic from './pages/WebinarPublic';
import FileExchange from './pages/FileExchange';
import FilePublic from './pages/FilePublic';
import Speakers from './pages/Speakers';
import Users from './pages/Users';
import Clients from './pages/Clients';
import UserLogs from './pages/UserLogs';
import SystemLogs from './pages/SystemLogs';
import Analytics from './pages/Analytics';
import Search from './pages/Search';
import Settings from './pages/Settings';
import InterfaceSettings from './pages/InterfaceSettings';
import HealthCheck from './pages/HealthCheck';
import Diplomas from './pages/Diplomas';
import LiveStream from './pages/LiveStream';
import ManagerInviteRegister from './pages/ManagerInviteRegister';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register/manager/:token" element={<ManagerInviteRegister />} />
          <Route path="/webinar/:id" element={<WebinarPublic />} />
          <Route path="/webinar/share/:slug" element={<WebinarPublic />} />
          <Route path="/files/share/:slug" element={<FilePublic />} />
          
          <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route path="/" element={<Navigate to="/webinars" replace />} />
            <Route path="/dashboard" element={<PrivateRoute role="moderator"><Dashboard /></PrivateRoute>} />
            <Route path="/webinars" element={<Webinars />} />
            <Route path="/webinars/:id" element={<WebinarDetail />} />
            <Route path="/live" element={<LiveStream />} />
            <Route path="/files" element={<PrivateRoute roles={['moderator', 'manager']}><FileExchange /></PrivateRoute>} />
            <Route path="/speakers" element={<PrivateRoute role="moderator"><Speakers /></PrivateRoute>} />
            <Route path="/users" element={<PrivateRoute role="moderator"><Users /></PrivateRoute>} />
            <Route path="/diplomas" element={<PrivateRoute roles={['moderator', 'manager']}><Diplomas /></PrivateRoute>} />
            <Route path="/clients" element={<PrivateRoute role="moderator"><Clients /></PrivateRoute>} />
            <Route path="/users/:userId/logs" element={<PrivateRoute role="moderator"><UserLogs /></PrivateRoute>} />
            <Route path="/logs/system" element={<PrivateRoute role="moderator"><SystemLogs /></PrivateRoute>} />
            <Route path="/settings" element={<PrivateRoute role="moderator"><Settings /></PrivateRoute>} />
            <Route path="/interface-settings" element={<PrivateRoute role="moderator"><InterfaceSettings /></PrivateRoute>} />
            <Route path="/health" element={<PrivateRoute role="moderator"><HealthCheck /></PrivateRoute>} />
            <Route path="/analytics" element={<PrivateRoute role="moderator"><Analytics /></PrivateRoute>} />
            <Route path="/search" element={<PrivateRoute role="moderator"><Search /></PrivateRoute>} />
          </Route>
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
      </Router>
    </AuthProvider>
  );
}

export default App;
